export const FORTNIGHT_COUNT = 26;

/**
 * Converts frontend fortnight (1-26) to backend week (2, 4, ..., 52).
 */
export const toBackendWeek = (fortnight) => fortnight * 2;

/**
 * Converts backend week to display fortnight. Handles legacy odd weeks (1,3,5,...)
 * and new even weeks (2,4,6,...). Returns '' for null/undefined.
 */
export const toFortnightDisplay = (backendWeek) =>
  backendWeek != null ? Math.ceil(Number(backendWeek) / 2) : "";
